import {Injectable} from '@angular/core';

declare var mapkit: any;

@Injectable(
  {providedIn: 'root'}
)
export class MapsHelperService {

  static readonly NAV_PARAM_STEP = 'step';
  static readonly NAV_PARAM_GPX = 'gpxUrl';

  iosMap: any;

  getStepMarker(coordinate: [number, number]): any {
    const stepPoint = new mapkit.Coordinate(coordinate[0], coordinate[1]);
    const stepPointAnnotation = new mapkit.MarkerAnnotation(stepPoint);
    stepPointAnnotation.color = '#FFA214';
    return stepPointAnnotation;
  }

  getLocationMarker(coordinate: [number, number]): any {
    const locationPoint = new mapkit.Coordinate(coordinate[0], coordinate[1]);
    const locationPointAnnotation = new mapkit.MarkerAnnotation(locationPoint);
    locationPointAnnotation.color = '#00aeef';
    return locationPointAnnotation;
  }

  getBeginMarker(coordinate: [number, number]): any {
    const startPoint = new mapkit.Coordinate(coordinate[0], coordinate[1]);
    const startPointAnnotation = new mapkit.MarkerAnnotation(startPoint);
    startPointAnnotation.color = '#FFA214';
    return startPointAnnotation;
  }

  getEndMarker(coordinate: [number, number]): any {
    const endPoint = new mapkit.Coordinate(coordinate[0], coordinate[1]);
    const endPointAnnotation = new mapkit.MarkerAnnotation(endPoint);
    endPointAnnotation.color = '#32db64';
    return endPointAnnotation;
  }

  getCoordinateRegion(coords: Array<[number, number]>): any {
    const allLats = coords.map(item => item[0]);
    const allLng = coords.map(item => item[1]);

    const maxLat = Math.max(...allLats);
    const minLat = Math.min(...allLats);

    const maxLng = Math.max(...allLng);
    const minLng = Math.min(...allLng);

    const centerCoords = this.getCenterFromDegrees(coords);
    return new mapkit.CoordinateRegion(
      new mapkit.Coordinate(centerCoords[0], centerCoords[1]),
      new mapkit.CoordinateSpan((maxLat - minLat), (maxLng - minLng))
    );
  }

  getRoutePolyLine(mapkitCoordinates: Array<[number, number]>): any {
    const mapKitCoords = mapkitCoordinates.map((point) => {
      return new mapkit.Coordinate(point[0], point[1]);
    });

    const style = new mapkit.Style({
      lineWidth: 3,
      lineJoin: 'round',
      strokeColor: '#FFA214'
    });

    return new mapkit.PolylineOverlay(mapKitCoords, {style: style});
  }

  getCenterFromDegrees(data: Array<number[]>): Array<number> {
    if (!(data.length > 0)) {
      return;
    }

    const coordsCount = data.length;

    let X = 0.0;
    let Y = 0.0;
    let Z = 0.0;

    for (let i = 0; i < data.length; i++) {
      const lat = data[i][0] * Math.PI / 180;
      const lon = data[i][1] * Math.PI / 180;

      const a = Math.cos(lat) * Math.cos(lon);
      const b = Math.cos(lat) * Math.sin(lon);
      const c = Math.sin(lat);

      X += a;
      Y += b;
      Z += c;
    }

    X /= coordsCount;
    Y /= coordsCount;
    Z /= coordsCount;

    const lon = Math.atan2(Y, X);
    const hyp = Math.sqrt(X * X + Y * Y);
    const lat = Math.atan2(Z, hyp);

    const newX = (lat * 180 / Math.PI);
    const newY = (lon * 180 / Math.PI);

    return [newX, newY];
  }

  mapToMapkitPoints(latLngLiterals: google.maps.LatLngLiteral[]): Array<[number, number]> {
    if (latLngLiterals === null || latLngLiterals === undefined) {
      return [];
    }
    return latLngLiterals.reduce((curr, prev) => {
      curr.push([prev.lat, prev.lng]);
      return curr;
    }, []);
  }
}
